import React, { PureComponent, Component, createRef } from 'react'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import { CardElement, injectStripe, StripeProvider, Elements } from 'react-stripe-elements'
import { openSuccessMessage } from '../../actions/message'

// You can customize your Elements to give it the look and feel of your site.
const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    },
  }
}

class _CardForm extends Component {
  state = {
    errorMessage: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      errorMessage: '',
    }
  }

  handleChange = (evt) => {
    const { error, complete } = evt
    const { dispatch, stripe, setNewSource, stripeCustomer } = this.props
    if (error) {
      this.setState({ errorMessage: error.message })
      // dispatch(openErrorMessage(error.message));
    } else {
      this.setState({ errorMessage: '' })
    }
    if (complete) {
      if (stripe) {
        stripe
          .createSource({
            type: 'card',
            owner: {
              name: stripeCustomer.name,
              address: stripeCustomer.address,
              phone: stripeCustomer.phone,
              email: stripeCustomer.email,
            },
          })
          .then(function (result) {
            if (result.error) {
              // Inform the user if there was an error
              var errorElement = document.getElementById('card-errors')
              if (errorElement) {
                errorElement.textContent = result.error.message
              }
            } else {
              dispatch(openSuccessMessage('Valid Credit Card'))
              const source = result.source
              setNewSource(source.id)
              document.getElementById('hidden-source').value = source.id
            }
          })
      } else {
        console.log("Stripe.js hasn't loaded yet.")
      }
    }
  }

  handleSubmit = (evt) => {
    evt.preventDefault()
    /* var ownerInfo = {
        owner: {
          name: 'Jenny Rosen',
          address: {
            line1: 'Nollendorfstraße 27',
            city: 'Berlin',
            postal_code: '10777',
            country: 'DE',
          },
          email: 'jenny.rosen@example.com'
        },
      }; */
    const { stripe } = this.props
    if (stripe) {
      stripe
        .createSource({
          type: 'card',
          owner: {
            name: 'Jenny Rosen',
          },
        })
        .then(function (result) {
          if (result.error) {
            // Inform the user if there was an error
            var errorElement = document.getElementById('card-errors')
            if (errorElement) {
              errorElement.textContent = result.error.message
            }
          } else {
            const source = result.source
            document.getElementById('hidden-source').value = source.id
          }
        })
    } else {
      console.log("Stripe.js hasn't loaded yet.")
    }
  }

  render() {
    return (
      <div className="CardDemo">
        <form id="form" onSubmit={this.handleSubmit.bind(this)}>
          <label>
            <CardElement
              dispatch={this.props.dispatch}
              onChange={this.handleChange}
              attachCustomerSource={this.props.attachCustomerSource}
              {...createOptions()}
            />
          </label>
          <div className="error" role="alert">
            {this.state.errorMessage}
          </div>
          {/* <Button variant="outlined" color="primary"  className="margin" onClick={this.openAddCardModal}>Add</Button> */}
          {/* <button id="button-submit">Add Card</button> */}
        </form>
      </div>
    )
  }
}

const CardForm = injectStripe(_CardForm)

class AddCardModal extends PureComponent {
  childRef = createRef()

  constructor(props) {
    super(props)
    this.state = {
      stripeApiKey: null,
      sourceId: null,
    }
  }

  componentDidMount() {
    if (process.env.REACT_APP_API_KEY) {
      this.setState({ stripeApiKey: process.env.REACT_APP_API_KEY })
    }
  }

  setNewSource = (source) => {
    this.setState({ sourceId: source })
  }

  onClose = () => {}

  onOpen = (type) => {}

  onConfirm = () => {
    // let value = document.getElementById('hidden-source').value;
    const { sourceId } = this.state
    if (sourceId) {
      this.props.attachNewSource(sourceId)
    }
  }

  render() {
    const { forwardedRef, stripeCustomer, dispatch } = this.props

    return (
      <ModalDialog
        title={'Add Credit Card'}
        ref={forwardedRef}
        onConfirm={this.onConfirm}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <input hidden id="hidden-source"></input>
        <StripeProvider apiKey={this.state.stripeApiKey}>
          <Elements>
            <CardForm
              dispatch={dispatch}
              setNewSource={this.setNewSource}
              handleResult={this.props.handleResult}
              stripeCustomer={stripeCustomer}
            />
          </Elements>
        </StripeProvider>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddCardModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddCardModal.js